import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbstractUiEntityStore } from '../../data/abstract-ui-entity.store';
import { SaleStat } from './sale-stat';
import { User } from 'projects/core/src/lib/login/data/user';
import { DatePeriod } from 'projects/app-misc/src/app/modules/reports/view/graphs-view/graphs-view.component';

export interface LineChartState extends EntityState<SaleStat, number> {
  ui: {
    events: SaleStat[]
    datePeriod: DatePeriod,
    selectedUsers: User[],
    dateFormat: string,
    chartType: string,
    chartLoading: boolean,
    usersInfo: SaleStat[]
  };
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({name: 'notifications'})
export class LineChartStore extends AbstractUiEntityStore<LineChartState> {
  constructor() {
    super({
      ui: {
        events: [],
        datePeriod: null,
        selectedUsers: [],
        dateFormat: '',
        chartLoading: false,
        chartType: '',
        usersInfo: []
      }
    })
  }

  updateLoading(chartLoading: boolean) {
    this.updateUi({
      chartLoading
    })
  }

  updateEvents(events: SaleStat[]) {
    this.updateUi({
      events
    })
  }

  updateDates(datePeriod: DatePeriod) {
    this.updateUi({
      datePeriod
    })
  }

  updateSelectedUsers(selectedUsers: User[]) {
    this.updateUi({
      selectedUsers
    })
  }

  updateDateFormat(dateFormat: string) {
    this.updateUi({
      dateFormat
    })
  }

  updateUsersInfo(usersInfo: SaleStat[]) {
    this.updateUi({
      usersInfo
    })
  }

  updateChartType(chartType: string) {
    this.updateUi({
      chartType
    })
  }
}
